import Helpers from '../../common/helpers/Helpers';
import Constants from '../../common/constants/Constants';

export const getFilesFromBlob = () => {
  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/files`);
};

export const deleteFileFromBlob = (blobUrl) => {
  let query = {
    blobUrl: blobUrl,
  };

  return Helpers.delete(`${Constants.FILE_TRANSFER_URL}/`, {}, query);
};

export const getReadOnlyBlobSasToken = (blobUrl) => {
  let query = {
    blobUrl: blobUrl,
  };

  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/sasToken`, {}, query);
};
